import { InvoicePayNowQuote, InvoiceProps } from './types';

export function getInvoicePayNowQuote(invoice: InvoiceProps): InvoicePayNowQuote | null {
    const quote = invoice.payNowQuote;
    if (!quote || quote.invoiceId !== invoice.id
        || !Number.isSafeInteger(quote.invoiceId) || quote.invoiceId <= 0
        || ![quote.baseAmountCents, quote.feeAmountCents, quote.officeAmountCents, quote.feeBasisPoints]
            .every(value => Number.isSafeInteger(value) && value >= 0)
        || quote.officeAmountCents !== quote.baseAmountCents + quote.feeAmountCents
        || typeof quote.feeWaived !== 'boolean'
        || (quote.feeWaived && (quote.feeAmountCents !== 0 || quote.feeBasisPoints !== 0))
        || !['cad', 'usd'].includes(quote.currency)) return null;
    return quote;
}

export function sameInvoicePayNowQuote(left: InvoicePayNowQuote | null, right: InvoicePayNowQuote | null): boolean {
    return !!left && !!right && left.invoiceId === right.invoiceId
        && left.baseAmountCents === right.baseAmountCents
        && left.feeAmountCents === right.feeAmountCents
        && left.officeAmountCents === right.officeAmountCents
        && left.feeBasisPoints === right.feeBasisPoints
        && left.feeWaived === right.feeWaived
        && left.currency === right.currency;
}

export const formatInvoiceCents = (cents: number): string => (cents / 100).toFixed(2);
